import { createSelector } from 'reselect';
import WixSDK from 'shared/utils/wix-sdk';

const getAllSettings = state => state.appSettings;

export const getAppLocale = createSelector(getAllSettings,
  settings => _.get(settings, 'fonts.language') || WixSDK.Utils.getLocale()
);



// WEBPACK FOOTER //
// ./src/widget/selectors/app-settings.js